export default "__VITE_ASSET__DmfyLNyS__"